import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './css/IdeaStage.css'

class IdeaStage extends Component {

    render(){

        var stageStyle = ''
        var stageElements = []
        if(!this.props.stageNames)
            return null
        var stageWidth = 100/this.props.stageNames.length+'%'

        for (let y = 0; y < this.props.stageNames.length; y++){
            if (y === this.props.stage){
                stageStyle = 'step current'
            }
            else if(y < this.props.stage){
                stageStyle = 'step done'
            }
            else{
                stageStyle = 'step'
            }
            stageElements.push(<div style={{width: stageWidth, cursor: this.props.cursor}} key={y} onClick={() => this.props.setStage(y)} className={stageStyle}> <span> {this.props.stageNames[y]} </span> </div>)
        }

        return (
        <div style={{width: 100+'%'}} className='stepsContainer'>
            <div style={{width: 100+'%'}} className='arrow-steps clearfix'>
                {stageElements}
            </div>
        </div>
        )
    }
}
IdeaStage.propTypes = {
    stage: PropTypes.number.isRequired,
    setStage: PropTypes.func.isRequired,
    stageNames: PropTypes.array,
    cursor: PropTypes.string,
}
IdeaStage.defaultProps = {
    stage: 0,
    stageNames: ['New Idea',
    'Screening',
    'Strenghten',
    'Evaluation',
    'Decide',
    'Done'],
}


export default IdeaStage



// WEBPACK FOOTER //
// ./src/components/IdeaStage.js